import { usePartner } from "../PartnerContext";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = ({ label = "Jetzt loslegen", className = "", size = "md", testid = "whatsapp-cta", pulse = false }) => {
  const { whatsappLink } = usePartner();
  const sizes = {
    sm: "px-4 py-2 text-xs sm:text-sm",
    md: "px-5 py-2.5 text-sm sm:px-6 sm:py-3 sm:text-base",
    lg: "px-6 py-3.5 text-sm sm:px-8 sm:py-4 sm:text-base md:text-lg",
  };
  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full bg-gradient-to-r from-[#1E90FF] to-[#60A5FA] font-bold text-[#05070D] shadow-lg shadow-[#1E90FF]/25 transition-all duration-300 hover:scale-105 hover:shadow-[0_0_36px_rgba(96,165,250,0.65)] active:scale-95 shine-sweep ${sizes[size]} ${pulse ? "pulse-ring" : ""} ${className}`}
    >
      <MessageCircle className="relative z-10 h-4 w-4 transition-transform duration-300 group-hover:rotate-12 sm:h-5 sm:w-5" strokeWidth={2.5} />
      <span className="relative z-10 whitespace-nowrap">{label}</span>
    </a>
  );
};
